import type { Country } from '../@types/Country.types';

/**
 * Available bank codes, per market — the set MyPage can render an offer for
 * (`Lender.ShortName` is parsed against `allBankCodes`) and the only values
 * the bank registry's `logoKey` may take (`./bank-registry.ts`).
 *
 * Data only: the logos live in `@axo/ui-content`
 * (`public/partners/bank/<market>/<code>.svg`, asserted by
 * `features/Partners/Bank/bank-assets.test.ts` there). Adding a code here
 * means adding its svg, and — for a registry market — a registry entry.
 */

const FI = [
  'AKT',
  'ALD',
  'AVI',
  'BN',
  'BON',
  'BRA',
  'BRO',
  'CRD',
  'CRR',
  'DBA',
  'FEF',
  'FEM',
  'FIX',
  'GFM',
  'HAL',
  'HIT',
  'IB',
  'KAR',
  'KB',
  'MBL',
  'NDA',
  'NDX',
  'NDX-alt',
  'NOR',
  'OMP',
  'OPF',
  'P1',
  'PAN',
  'POP',
  'RB',
  'REM',
  'SAL',
  'SRC',
  'STP',
  'SVK',
] as const;

const NO = [
  'AVI',
  'BA2',
  'BB',
  'BBB',
  'BN',
  'BRA',
  'EIK',
  'EKS',
  'EB',
  'ESY',
  'FCB',
  'FEM',
  'GB',
  'IB',
  'IKA',
  'KB',
  'KF',
  'MB',
  'NDO',
  'NDX',
  'NOR',
  'RB',
  'REM',
  'SCB',
  'SCB-alt',
  'SVF',
  'THR',
  'YA',
  'BST',
] as const;

const SE = [
  'AVI',
  'BAL',
  'BKB',
  'BKY',
  'BN',
  'BRA',
  'BRI-alt',
  'BRI',
  'BRX',
  'BRO',
  'BST',
  'CBY',
  'COL',
  'CRD',
  'EQL',
  'ERL',
  'FCB',
  'FEM',
  'FLX',
  'FRI',
  'FRL',
  'FT',
  'FX',
  'IB',
  'ICA',
  'IKA',
  'KB',
  'LDF',
  'LSB',
  'LTP',
  'MG',
  'MMA',
  'MOA',
  'MOG',
  'NDX',
  'NNK',
  'NNT',
  'NOC',
  'NOP',
  'NSF',
  'NSM',
  'PNL',
  'RB',
  'REM',
  'SAL',
  'SDF',
  'SPW',
  'ST',
  'SVK',
  'SVK-alt',
  'SVP',
  'SVP-alt',
  'TAN',
  'TF',
  'THR',
  'TRK',
  'WAS',
  'WGF',
] as const;

const DK = [
  'BB',
  'BN',
  'COP',
  'EB',
  'FB',
  'FR',
  'IK',
  'LEN',
  'MF',
  'ND',
  'NF',
  'RB',
  'RE',
  'SN',
  'SNH',
  'SX',
  'TF',
  'UL',
] as const;

export const allBankCodes = [...FI, ...NO, ...SE, ...DK] as const;
// 👆 is temporary to fix 👇
// FIXME data model is not ok, flatten first, country specific variations as exception (f.ex. nordax having a variant of the logo in some countries)
export const bankCodes: Partial<Record<Country, readonly BankCode[]>> = {
  FI,
  NO,
  SE,
  DK,
};

export type BankCode =
  | (typeof FI)[number]
  | (typeof NO)[number]
  | (typeof SE)[number]
  | (typeof DK)[number];
